import { Component } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { HttpParams } from '@angular/common/http'
import { WjGridModule } from '@grapecity/wijmo.angular2.grid'
import { WjInputModule } from '@grapecity/wijmo.angular2.input'

import {
    BaseComponent,
    FeatureType,
    Grid,
    JobType,
    JobTypeVendor,
    ModalSize,
    Vendor,
} from '../../shared'
import { ActionToolbarCount } from '../../shared/reusable-components/action-toolbar-count/action-toolbar-count.component'
import { ActionToolbarSearchComponent } from '../../shared/reusable-components/action-toolbar-search/action-toolbar-search.component'
import { AutoSizeDirective } from '../../shared/utility/auto-size.directive'
import { JobTypeVendorTemplateComponent } from './job-type-vendor-template.component'

@Component({
    selector: 'app-job-type-vendor-templates',
    templateUrl: './job-type-vendor-templates.component.html',
    styleUrls: ['./job-type-vendor-templates.component.css'],
    standalone: true,
    imports: [
        FormsModule,
        ActionToolbarCount,
        ActionToolbarSearchComponent,
        WjGridModule,
        WjInputModule,
        AutoSizeDirective,
    ],
})
export class JobTypeVendorTemplatesComponent extends BaseComponent {
    grid: Grid<JobTypeVendor>
    jobTypes: JobType[] = []
    vendors: Vendor[] = []
    vendorItems: JobTypeVendor[] = []
    selectedJobTypeId = ''

    get canEdit() {
        return this.services.authentication.hasFeature([FeatureType.FieldToolsPoConfigEdit])
    }

    constructor() {
        super()
        this.grid = new Grid<JobTypeVendor>(this.services)
            .wrapColumnHeaders()
            .isReadOnly(true)
            .filterBy(item => [item.vendorName])

        this.refresh()
    }

    refresh() {
        this.cancelableRequest(
            '',
            true,
            this.services.data
                .load(
                    true,
                    true,
                    this.services.data.jobTypes.queryAll(),
                    this.services.data.vendors.queryAll(),
                )
                .subscribe({
                    next: result => {
                        this.jobTypes = result[0] as JobType[]
                        this.vendors = result[1] as Vendor[]

                        if (this.jobTypes.length > 0 && !this.selectedJobTypeId) {
                            this.selectedJobTypeId = this.jobTypes[0].id
                        }

                        this.loadVendorsForJobType()
                    },
                }),
        )
    }

    onJobTypeChanged() {
        this.loadVendorsForJobType()
    }

    loadVendorsForJobType() {
        if (!this.selectedJobTypeId) {
            this.vendorItems = []
            this.grid.items = []
            this.initialLoadingComplete()
            return
        }

        this.cancelableRequest(
            'vendors',
            false,
            this.services.data
                .load(
                    true,
                    true,
                    this.services.data.get<JobTypeVendor[]>(
                        'api/JobTypeVendor/GetByJobType',
                        new HttpParams().set('jobTypeId', this.selectedJobTypeId),
                    ),
                )
                .subscribe({
                    next: result => {
                        this.initialLoadingComplete()
                        this.vendorItems = result[0]
                        this.grid.items = this.vendorItems
                    },
                }),
        )
    }

    manageVendors() {
        if (!this.selectedJobTypeId) return

        const ref = this.services.modals.open(JobTypeVendorTemplateComponent, ModalSize.large)
        const modal = ref.componentInstance as JobTypeVendorTemplateComponent
        modal.jobTypeId = this.selectedJobTypeId
        modal.allVendors = this.vendors
            .map(v => ({ id: v.id, name: v.name }))
            .sort((a, b) => a.name.localeCompare(b.name))
        modal.selectedVendorIds = this.vendorItems.map(v => v.vendorId)

        ref.result
            .then((result: JobTypeVendor[]) => {
                if (result) {
                    this.vendorItems = result
                    this.grid.items = this.vendorItems
                }
            })
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            .catch(() => {})
    }
}
